<div class="compliance-review-body">
  <app-display-card [innerPanel]="true">
    <div class="final-review-placeholder">
      <i class="bi bi-clipboard-check final-review-placeholder__icon"></i>
      <h3 class="mb-1">Final review</h3>
      <p class="mb-0 text-secondary">This step is not built out yet.</p>
    </div>
  </app-display-card>
</div>
